import React from "react";
import { LazyMotion, m } from "framer-motion";

export type AnimationBehaviors = "fadeInUp" | "lengthen";

interface Props {
  behavior: AnimationBehaviors;
  className?: string;
}

const loadFeatures = () =>
  import("../../animation/features").then((res) => res.default);

const AnimationWrapper: React.FC<Props> = ({
  behavior,
  className,
  children,
  ...props
}) => {
  const behaviors = {
    fadeInUp: {
      initial: {
        opacity: 0,
        y: 50,
      },
      whileInView: {
        opacity: 1,
        y: 0,
      },
      transition: {
        delay: 0.25,
        duration: 1,
      },
      viewport: {
        once: true,
      },
    },
    lengthen: {
      initial: {
        scaleX: 0.5,
        opacity: 0.4,
        y: "-50%",
      },
      animate: {
        scaleX: 1,
        opacity: 1,
        y: "-50%",
      },
      transition: {
        delay: 0,
        duration: 1.5,
      },
      style: {
        originX: "left",
      },
    },
  };

  return (
    <LazyMotion features={loadFeatures}>
      <m.div className={className} {...behaviors[behavior]}>
        {children}
      </m.div>
    </LazyMotion>
  );
};

export default AnimationWrapper;
